import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { mainColor } from '../../constants/theme';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    summary: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      padding: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
      borderRadius: 12,
      backgroundColor: '#f2f4f7',
    },
    summaryIcon: {
      display: 'flex',
      flex: '0 0 40px',
      width: 40,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      color: mainColor.secondaryColor,
      backgroundColor: '#e5f4ef',
    },
    summaryTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: '#1f2937',
    },
    summaryDetails: {
      fontSize: 12,
      color: '#687080',
    },
    helperText: {
      minHeight: 18,
      margin: 0,
      fontSize: 12,
      color: '#737780',
    },
    error: {
      color: '#d32f2f',
    },
    submitError: {
      marginTop: theme.spacing(2),
      borderRadius: 10,
      fontSize: 13,
    },
    preview: {
      textAlign: 'center',
    },
    previewIcon: {
      display: 'flex',
      width: 50,
      height: 50,
      alignItems: 'center',
      justifyContent: 'center',
      margin: `0 auto ${theme.spacing(1.5)}px`,
      borderRadius: '50%',
      color: mainColor.secondaryColor,
      backgroundColor: '#e5f4ef',
    },
    previewTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: 600,
      color: '#1f2937',
    },
    previewText: {
      color: '#687080',
      fontSize: 13,
    },
    previewEmail: {
      display: 'block',
      margin: theme.spacing(0.5, 0),
      color: '#1f2937',
      fontWeight: 600,
      fontSize: 13,
      overflowWrap: 'anywhere',
    },
    previewHint: {
      marginTop: theme.spacing(2.5),
      color: '#687080',
      fontSize: 13,
    },
    retryButton: {
      padding: 0,
      border: 0,
      background: 'none',
      color: mainColor.secondaryColor,
      font: 'inherit',
      textDecoration: 'underline',
      cursor: 'pointer',
      '&:focus-visible': {
        outline: `2px solid ${mainColor.secondaryColor}`,
        outlineOffset: 2,
      },
    },
  }),
);
